import { classNames } from "../utils/class-names";

export type ActionTriggerState = "unselected" | "selected" | "disabled";

type ActionTriggerVariant = "normal" | "small" | "fixed";

export const globalActionTriggerClassNames =
  "rounded-lg border-shale-700 font-sans font-medium hover:ease-in duration-100 hover:cursor-pointer";

export const actionTriggerClassMap: Record<
  ActionTriggerVariant,
  Record<ActionTriggerState | "all", string>
> = {
  normal: {
    all: "border lg:border-0 text-sm sm:text-base lg:text-lg p-2.5 lg:p-0",
    unselected:
      "text-blue-300 hover:bg-shale-750 lg:hover:bg-transparent hover:text-blue-200 active:bg-shale-850 lg:active:bg-transparent",
    selected: "text-white bg-shale-700 lg:bg-transparent",
    disabled: "text-shale-400 pointer-events-none",
  },
  small: {
    all: "border lg:border-0 text-sm lg:text-base px-5 py-2.5 lg:px-0 lg:py-0",
    unselected:
      "text-blue-300 hover:bg-shale-750 lg:hover:bg-transparent hover:text-blue-200 active:bg-shale-850 lg:active:bg-transparent",
    selected: "text-white bg-shale-700 lg:bg-transparent",
    disabled: "text-shale-400 pointer-events-none",
  },
  fixed: {
    all: "border text-base px-5 py-2.5",
    unselected:
      "text-blue-300 hover:bg-shale-750 hover:text-blue-200 active:bg-shale-850",
    selected: "text-white bg-shale-700",
    disabled: "text-shale-400 pointer-events-none",
  },
};

export const getActionTriggerClassNames = (
  variant: ActionTriggerVariant,
  state: ActionTriggerState
) =>
  classNames(
    globalActionTriggerClassNames,
    actionTriggerClassMap[variant]["all"],
    actionTriggerClassMap[variant][state]
  );

export const actionContainerClassMap: Record<ActionTriggerVariant, string> = {
  normal: "flex lg:py-5 gap-2.5 lg:gap-7",
  small: "flex gap-2.5 lg:py-2.5",
  fixed: "flex gap-5",
};

export const getActionContainerClassNames = (variant: ActionTriggerVariant) =>
  actionContainerClassMap[variant];
